'use client';

import a__default, { memo, forwardRef } from "react";
import { classNames } from "../../utils/styles/classNames.js";
import { Text } from "../Text/Text.js";
import { ArrowSquareOut } from "../../../react-icons.js";
import { CustomAnchor } from "../../quarks/CustomAnchor/CustomAnchor.js";
import { container, linkAsButton, afterContainer } from "./Link.css.js";
import { newWindowIndication } from "./Link.data.js";
import { getIconSize } from "./utils/getIconSize.js";
import { allowedVariants } from "./utils/constants.js";
import { getEmphasisClassName } from "./utils/getEmphasisClassName.js";
import { defaultProps } from "./Link.defaultProps.js";
const Link = (
  /* #__PURE_ */
  memo(forwardRef(LinkComponent))
);
function LinkComponent(props, ref) {
  if ("href" in props) {
    return renderAsAnchor(props, ref);
  }
  return renderAsButton(props, ref);
}
function renderAsAnchor({
  emphasis,
  a11yLabel,
  onDark,
  children,
  className,
  target,
  variant,
  dataQa,
  ...rest
}, ref) {
  return /* @__PURE__ */ a__default.createElement(
    CustomAnchor,
    {
      className: classNames(
        className,
        container,
        getEmphasisClassName({ emphasis, onDark })
      ),
      "data-qa": dataQa,
      ref,
      target,
      ...rest
    },
    renderContent({ a11yLabel, variant, children, target })
  );
}
function renderAsButton({
  emphasis,
  a11yLabel,
  onDark,
  children,
  className,
  variant,
  disabled,
  dataQa,
  target,
  ...rest
}, ref) {
  return /* @__PURE__ */ a__default.createElement(
    "button",
    {
      ...rest,
      "aria-disabled": disabled,
      className: classNames(
        className,
        container,
        getEmphasisClassName({ emphasis, onDark }),
        linkAsButton
      ),
      "data-qa": dataQa,
      ref,
      type: "button"
    },
    renderContent({ a11yLabel, variant, children, target })
  );
}
function renderContent({
  a11yLabel,
  children,
  target,
  variant: variantProp
}) {
  const hasA11yLabel = a11yLabel ? a11yLabel.length > 0 : false;
  const isExternal = target === "_blank";
  const variant = variantProp && allowedVariants.includes(variantProp) ? variantProp : defaultProps.variant;
  return /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(Text, { "aria-hidden": hasA11yLabel ? "true" : void 0, variant }, children), hasA11yLabel && /* @__PURE__ */ a__default.createElement(Text, { visuallyHidden: true }, a11yLabel), isExternal && /* @__PURE__ */ a__default.createElement(Text, { visuallyHidden: true }, newWindowIndication), isExternal && /* @__PURE__ */ a__default.createElement("span", { className: afterContainer }, /* @__PURE__ */ a__default.createElement(ArrowSquareOut, { size: getIconSize({ variant }) })));
}
export {
  Link
};
